// src/api/mongodb/update-chosen-delivery-option-fbr-dbb.js

/**
 * Slaat de gekozen deliveryOption op voor één of meerdere orderItems.
 *
 * @param {string} token - JWT token
 * @param {object|string} order - Order object (met .id/.orderId) of direct een order-id string
 * @param {array|object|string} orderItemsOrIds - Array van orderItem objects, array van ids, of één id/object
 * @param {object} deliveryOption - De gekozen deliveryOption (van Bol)
 */
const saveDeliveryOptionFbrDbb = async (
  token,
  order,
  orderItemsOrIds,
  deliveryOption
) => {
  // 1) Order-id normaliseren
  const orderDbId = typeof order === "string" ? order : order?.id;
  const bolOrderId = typeof order === "string" ? undefined : order?.orderId;

  // 2) orderItems normaliseren → altijd array van strings
  const normalizeOrderItemIds = (input) => {
    if (!input) return [];

    // Als het al een array is:
    if (Array.isArray(input)) {
      // Als het een array van objects is → pak .orderItemId of .id
      if (input.length > 0 && typeof input[0] === "object") {
        return input
          .map((oi) => oi?.orderItemId || oi?.id || oi)
          .filter(Boolean)
          .map(String);
      }
      // Array van primitieve waarden (strings/nummers)
      return input.filter(Boolean).map(String);
    }

    // Los object → pak .orderItemId of .id
    if (typeof input === "object") {
      const v = input.orderItemId || input.id;
      return v ? [String(v)] : [];
    }

    // Losse string/nummer
    return [String(input)];
  };

  const orderItemIds = normalizeOrderItemIds(orderItemsOrIds);

  const body = {
    id: orderDbId,        // DB-order veld "id"
    orderId: bolOrderId,  // Bol orderId (optioneel, voor logging)
    orderItems: orderItemIds,
    deliveryOption,
  };

  console.log("[saveDeliveryOptionFbrDbb] payload:", body);

  if (!body.id || !body.orderItems.length) {
    throw new Error(
      "Missing id of orderItems in saveDeliveryOptionFbrDbb payload"
    );
  }

  const res = await fetch(
    process.env.REACT_APP_ASSET_URL +
      "/bol/orders/open/fbr/dbb/order/delivery-option",
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(body),
    }
  );

  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const data = isJson ? await res.json().catch(() => ({})) : {};

  if (!res.ok) {
    console.error("[saveDeliveryOptionFbrDbb] error:", res.status, data);
    throw new Error(
      data?.message ||
        `PATCH request body is not correct, please check your request`
    );
  }

  return data;
};

export default saveDeliveryOptionFbrDbb;
